import script from "./Impersonations.vue?vue&type=script&setup=true&lang=js"
export * from "./Impersonations.vue?vue&type=script&setup=true&lang=js"

import "./Impersonations.vue?vue&type=style&index=0&id=70372032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70372032"]])

export default __exports__